export function getSunburstAlerts(): string[] {
  const alerts: string[] = [];
  // No specific alerts for sunburst chart
  return alerts;
}
